import React from 'react';
import { Navigate } from 'react-router-dom';
import { pr, r } from './helpers';
import {
  DashboardPage,
  BranchDashboardPage,
  UsersPage,
  BranchesPage,
  BranchDetailPage,
  BranchSelectPage,
  RidersPage,
  RiderMonitoringPage,
  DispatchCenterPage,
  CustomersPage,
  CustomerProfilePage,
  ShopOrdersPage,
  ShopOrderCreatePage,
  ShopOrderDetailPage,
  ShopInboxPage,
  RiderFinancePage,
  RiderFloatPage,
  RiderProfilePage,
  ShopSettingsPage,
  MerchantsPage,
  MerchantDetailPage,
  OrdersPage,
  CompanyBulkUploadPage,
  CompanyBulkUpdatePage,
  OrderDetailPage,
  NotificationsPage,
  ReportsPage,
  RiderSettlementsPage,
  MerchantPayoutsPage,
  ExpensesPage,
  CompanySettingsPage,
  CompanyWorkflowPage,
  NotificationSettingsPage,
  LabelDesignerPage,
  ReportDesignerPage,
  LabelPage,
  BatchLabelsPage,
  TenantProfilePage,
} from '../lazyPages';

const STAFF = ['company', 'user'];

/** Company staff portal routes (authenticated on company subdomain or apex). */
export function CompanyProtectedRoutes() {
  return (
    <>
      {pr('/branch-select', BranchSelectPage, STAFF)}
      {pr('/b/:branchCode', BranchDashboardPage, STAFF, undefined, 'branches.view')}
      {pr('/', DashboardPage, STAFF, undefined, 'dashboard.view')}
      {pr('/customers', CustomersPage, STAFF, undefined, 'customers.view')}
      {pr('/customers/:customerId', CustomerProfilePage, STAFF, undefined, 'customers.view')}
      {pr('/requests', ShopOrdersPage, STAFF, undefined, 'orders.view')}
      {pr('/requests/new', ShopOrderCreatePage, STAFF, undefined, 'orders.create')}
      {pr('/requests/:orderId', ShopOrderDetailPage, STAFF, undefined, 'orders.view')}
      {pr('/inbox', ShopInboxPage, STAFF, undefined, 'chat.view')}
      {pr('/rider-finance', RiderFinancePage, STAFF, undefined, 'rider_settlements.view')}
      {pr('/rider-order-settlements', RiderFinancePage, STAFF, undefined, 'rider_settlements.view')}
      {pr('/rider-float', RiderFloatPage, STAFF, undefined, 'rider_finance.view')}
      {pr('/riders/:riderId', RiderProfilePage, STAFF, undefined, 'riders.view')}
      {pr('/shop-settings', ShopSettingsPage, STAFF, undefined, 'settings.view')}
      {pr('/users', UsersPage, STAFF, undefined, 'users.view')}
      {r('/roles', <Navigate to="/users" replace />)}
      {pr('/branches', BranchesPage, STAFF, undefined, 'branches.view', 'merchant_shipping')}
      {pr('/branches/:branchId', BranchDetailPage, STAFF, undefined, 'branches.view', 'merchant_shipping')}
      {pr('/riders', RidersPage, STAFF, undefined, 'riders.view')}
      {pr('/rider-monitoring', RiderMonitoringPage, STAFF, undefined, 'riders.monitor')}
      {r('/rider-monitoring/map', <Navigate to="/dispatch-center" replace />)}
      {pr('/dispatch-center', DispatchCenterPage, STAFF, undefined, 'dispatch.view', 'merchant_shipping')}
      {pr('/merchants', MerchantsPage, STAFF, undefined, 'merchants.view', 'merchant_shipping')}
      {pr('/merchants/:merchantId', MerchantDetailPage, STAFF, undefined, 'merchants.view_details', 'merchant_shipping')}
      {pr('/orders', OrdersPage, STAFF, undefined, 'orders.view', 'merchant_shipping')}
      {pr('/orders/bulk', CompanyBulkUploadPage, STAFF, undefined, 'orders.create', 'merchant_shipping')}
      {pr('/orders/bulk-update', CompanyBulkUpdatePage, STAFF, undefined, 'orders.edit', 'merchant_shipping')}
      {pr('/orders/labels/batch', BatchLabelsPage, STAFF, undefined, 'orders.export', 'merchant_shipping')}
      {pr('/orders/:orderId/label', LabelPage, STAFF, undefined, 'orders.export', 'merchant_shipping')}
      {pr('/orders/:orderId', OrderDetailPage, STAFF, undefined, 'orders.view', 'merchant_shipping')}
      {pr('/notifications', NotificationsPage, STAFF, undefined, 'notifications.view')}
      {pr('/reports', ReportsPage, STAFF, undefined, 'reports.view', 'merchant_shipping')}
      {pr('/rider-settlements', RiderSettlementsPage, STAFF, undefined, 'rider_settlements.view', 'merchant_shipping')}
      {pr('/merchant-payouts', MerchantPayoutsPage, STAFF, undefined, 'merchant_settlements.view', 'merchant_shipping')}
      {pr('/expenses', ExpensesPage, STAFF, undefined, 'expenses.view')}
      {pr('/settings', CompanySettingsPage, STAFF, undefined, 'settings.view')}
      {pr('/workflow', CompanyWorkflowPage, STAFF, undefined, 'workflow.view')}
      {pr('/settings/notifications', NotificationSettingsPage, STAFF, undefined, 'notifications.view')}
      {pr('/label-designer', LabelDesignerPage, STAFF, { companyMode: true }, 'orders.export')}
      {pr('/report-designer', ReportDesignerPage, STAFF, undefined, 'reports.design', 'merchant_shipping')}
      {pr('/profile', TenantProfilePage, STAFF, undefined, 'profile.view')}
    </>
  );
}